import ApiService from './api.service'

const ExpensesService = {
	saveExpensesService: (data) => {
		return ApiService.post(`expenses/create`, data);
	},
	searchFilterService: (data) => {
		return ApiService.post(`expenses/search	/${data.search.page}/${data.search.limit}`, data.filter);


	},
	getAllExpenses(data) {
		return ApiService.post(`expenses/search`, data);
	},
	deleteExpenses(id) {
		return ApiService.delete(`expenses/delete/${id}`);
	},
	getByIdExpensesService(id) {
		return ApiService.get(`expenses/get/${id}`);
	},
	updateExpenses(data) {
		return ApiService.post(`expenses/edit/${data.id}`, data);
	}
}
export default ExpensesService;
